module.exports = __webpack_public_path__ + "img/operating_records_dish_tl.5e1347aa.svg";